<template>
  <table class="table" cellspacing="0">
    <thead>
      <tr>
        <th v-for="header in headers" :align="header.align" :key="header.value">
          {{ header.label }}
        </th>
      </tr>
    </thead>
    <tbody>
      <template v-if="dynamicItems.length > 0">
        <tr v-for="item in dynamicItems" :key="item.id">
          <td :align="header.align" v-for="(header, i) in headers" :key="i">
            <slot :name="header.value" v-bind="item">{{
              item[header.value]
            }}</slot>
          </td>
        </tr>
      </template>

      <tr v-if="loading">
        <td :colspan="headers.length">
          <Loader />
        </td>
      </tr>
      <tr v-if="!loading && error">
        <td :colspan="headers.length">
          <slot><FailedToLoad /></slot>
        </td>
      </tr>
      <template v-else-if="!loading && dynamicItems.length === 0">
        <tr>
          <td :colspan="headers.length" align="center">
            <slot name="empty">No results</slot>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import Loader from '@/components/global/Loader';
import FailedToLoad from '@/components/global/FailedToLoad';

export default {
  name: 'm-table',
  props: ['headers', 'items', 'loading', 'error'],
  components: { Loader, FailedToLoad },
  computed: {
    dynamicItems() {
      return this.items;
    },
  },
};
</script>
